import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormErrorStateMatcher, FormService } from '../../core/form.service';
import { Unpaid, UnpaidService } from '../../core/unpaid.service';
import { FormGroup } from '@angular/forms';
import { ErrorService, SplittypayError } from '../../core/error.service';

@Component({
  selector: 'app-unpaid-set-note-dialog',
  templateUrl: './unpaid-set-note-dialog.component.html',
  styleUrls: ['./unpaid-set-note-dialog.component.scss'],
})
export class UnpaidSetNoteDialogComponent {
  unpaid_set_note_form_group: FormGroup = this.form_service.unpaid_set_note_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_setting_note_running: boolean = false;
  editing: boolean = false;

  unpaid?: Unpaid;

  constructor(
    private dialog_ref: MatDialogRef<UnpaidSetNoteDialogComponent>,
    private form_service: FormService,
    private error_service: ErrorService,
    private unpaid_service: UnpaidService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.unpaid = data.unpaid;
  }

  ngOnInit(): void {
    this.unpaid_set_note_form_group.get('note')?.setValue(this.unpaid?.note);
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.unpaid_set_note_form_group);
  }

  onSetNoteClick(): void {
    if (this.isFormValid() && this.unpaid?.store_id && this.unpaid?.order_id) {
      this.unpaid.note = this.unpaid_set_note_form_group.get('note')?.value;
      this.is_setting_note_running = true;

      this.unpaid_service.setNote(this.unpaid).subscribe({
        next: () => {
          this.dialog_ref.close({ success: true });
          this.is_setting_note_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          this.dialog_ref.close({ error: processed_error });
          this.is_setting_note_running = false;
        },
      });
    } else {
      this.error_service.processGenericApiError('Error during setting unpaid step note');
    }
  }

  startEditing(): void {
    this.editing = true;
  }
}
